/**
 * Статус компании по флагам Gorko.
 * isGorkoCommission → Комиссия
 * isGorkoAbonent → Абонентка (commission=0 & paid=1)
 * isGorkoHidden → Скрыто
 * isGorkoDeleted → Удалено
 */
export const mapCompanyGorkoStatus = (company) => {
	if (!company) return '—';

	const labels = [];

	if (company.isGorkoCommission) {
		labels.push('Комиссия');
	} else if (company.isGorkoAbonent) {
		labels.push('Абонентка');
	}

	if (company.isGorkoHidden) {
		labels.push('Скрыто');
	}

	if (company.isGorkoDeleted) {
		labels.push('Удалено');
	}

	return labels.length ? labels.join(', ') : '—';
};

export const GORKO_STATUS_FILTER_OPTIONS = [
	{ value: 'commission', label: 'Комиссия' },
	{ value: 'abonent', label: 'Абонентка' },
	{ value: 'hidden', label: 'Скрыто' },
	{ value: 'deleted', label: 'Удалено' },
];

export const getGorkoStatusFilterLabel = (value) => {
	return (
		GORKO_STATUS_FILTER_OPTIONS.find((option) => option.value === String(value))
			?.label ?? String(value)
	);
};

const GORKO_STATUS_TO_FIELD = {
	commission: 'isGorkoCommission',
	abonent: 'isGorkoAbonent',
	hidden: 'isGorkoHidden',
	deleted: 'isGorkoDeleted',
};

/**
 * UI-фильтр gorkoStatus → поля CompanyFilterInput (isGorko*).
 * Несколько значений объединяются через AND на уровне флагов.
 */
export const mapGorkoStatusFilterToGraphql = (gorkoStatus) => {
	const values = Array.isArray(gorkoStatus?.eq)
		? gorkoStatus.eq
		: gorkoStatus?.eq != null
			? [gorkoStatus.eq]
			: [];

	if (!values.length) return {};

	const filters = {};

	for (const value of values) {
		const field = GORKO_STATUS_TO_FIELD[String(value)];
		if (field) {
			filters[field] = { eq: true };
		}
	}

	return filters;
};
